import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

import {stategame} from '@/states/game.js';

// @TODO
class ScriptBrick1x1x1 extends HYPERCUBEJS.Script {

    $tocolor = false;

    $colorized = false;

    $model;

    constructor($model) {

        super();

        this.$model = $model;
        this.$delay = Math.random() * 4000;
    }

    onstart($entity) {

        if (this.$model === 'mountain') {

            const color = new HYPERCUBEJS.MaterialColor('mountain', {

                'color': [0.8 + (Math.random() * .2), 0.2 + (Math.random() * .2), 0.2 + (Math.random() * .2)]
            });

            $entity.meshes[0].setmaterial(color);
        }

        if (this.$model === 'tree') {

            const color = new HYPERCUBEJS.MaterialColor('tree', {

                'color': [0.2 + (Math.random() * .2), 0.5 + (Math.random() * .2), 0.2 + (Math.random() * .2)]
            });

            $entity.meshes[0].setmaterial(color);
        }

        if (this.$model === 'temple') {

            const color = new HYPERCUBEJS.MaterialColor('tree', {

                'color': [0.4 + (Math.random() * .2), 0.6 + (Math.random() * .2), 0.8 + (Math.random() * .2)]
            });

            $entity.meshes[0].setmaterial(color);
        }

        stategame.watchstate(() => {

            if (this.$colorized === false
            && stategame.getstate().mountain === true
            && this.$model === 'mountain') {

                this.$tocolor = true;
            }

            if (this.$colorized === false
            && stategame.getstate().tree === true
            && this.$model === 'tree') {

                this.$tocolor = true;
            }

            if (this.$colorized === false
            && stategame.getstate().temple === true
            && this.$model === 'temple') {

                this.$tocolor = true;
            }
        })
    }

    ontick($timeframe, $entity) {

        if (this.$tocolor === true
        && this.$colorized === false) {

            this.$delay -= $timeframe;

            if (this.$delay > 0) {

                return;
            }

            if (stategame.getstate().mountain === true
            && this.$model === 'mountain') {

                const gray = 0.8 + 0.2 * Math.random();

                const color = new HYPERCUBEJS.MaterialColor('plop', {

                    // 'color': [Math.random(), Math.random(), Math.random()]
                    // 'color': [Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5]
                    // 'color': [1.0, 1.0, 1.0]
                    'color': [gray, gray, gray]
                });

                $entity.meshes[0].setmaterial(color);

                this.$colorized = true;
            }

            if (stategame.getstate().tree === true
            && this.$model === 'tree') {

                const gray = 0.8 + 0.2 * Math.random();

                const color = new HYPERCUBEJS.MaterialColor('plop', {

                    // 'color': [Math.random(), Math.random(), Math.random()]
                    // 'color': [Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5]
                    // 'color': [1.0, 1.0, 1.0]
                    'color': [gray, gray, gray]
                });

                $entity.meshes[0].setmaterial(color);

                this.$colorized = true;
            }

            if (stategame.getstate().temple === true
            && this.$model === 'temple') {

                const gray = 0.8 + 0.2 * Math.random();

                const color = new HYPERCUBEJS.MaterialColor('plop', {

                    // 'color': [Math.random(), Math.random(), Math.random()]
                    // 'color': [Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5, Math.random() * 0.5 + 0.5]
                    // 'color': [1.0, 1.0, 1.0]
                    'color': [gray, gray, gray]
                });

                $entity.meshes[0].setmaterial(color);

                this.$colorized = true;
            }
        }
    }
}

export {

    ScriptBrick1x1x1
};

export default ScriptBrick1x1x1;
